import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Title } from '@angular/platform-browser';
import { ClientService } from './app/services/client.service';
import { filter, first } from 'rxjs/operators';
import * as Sentry from '@sentry/angular';

if (environment.production) {
  enableProdMode();
}

// El DSN de Sentry es público por diseño (solo permite enviar eventos, no leerlos),
// por eso va hardcodeado acá en vez de en setting.ts (que está gitignored y es
// config por-entorno: si se olvida copiar en un ambiente nuevo, Sentry queda mudo
// justo donde más importa).
Sentry.init({
  dsn: 'https://25bac2f6e7bd37dd0569146b09f29db8@o4511650579546112.ingest.us.sentry.io/4511667998031872',
  environment: environment.name,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.2,
});

// ✅ Función para convertir hex a rgb
function hexToRgb(hex: string): { r: number; g: number; b: number } | null {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

// ✅ Función para aplicar colores dinámicos
function applyDynamicColors(clientData: any) {
  const primaryColor = clientData?.clients_setting_global?.color_main_1 || '#0056a7';

  // ✅ Establecer variable CSS global
  document.documentElement.style.setProperty('--primary-color', primaryColor);

  // ✅ Establecer RGB para usar en rgba()
  const rgb = hexToRgb(primaryColor);
  if (rgb) {
    document.documentElement.style.setProperty('--primary-color-rgb', `${rgb.r}, ${rgb.g}, ${rgb.b}`);
  }

}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then((moduleRef) => {
    const titleService = moduleRef.injector.get(Title);
    const clientService = moduleRef.injector.get(ClientService);

    // ✅ Esperar a que los datos del cliente estén disponibles
    clientService.clientData$
      .pipe(
        filter(data => data !== null),
        first()
      )
      .subscribe((clientData) => {
        const title = clientData?.clients_setting_global?.title || 'Mi Aplicación';
        titleService.setTitle(title);
      });

    // ✅ Fallback: si los datos ya están disponibles sincrónicamente
    const existingData = clientService.getClientData();

    if(existingData) {
  if (existingData?.clients_setting_global?.title) {
      titleService.setTitle(existingData.clients_setting_global.title);
    }
       applyDynamicColors(existingData);
    }

  })
  .catch((err) => console.error('Error bootstrapping app:', err));
